export const GameConfigs = {
	//INITIAL CONFIGS
	init: false,
	auth: {
		balance: {
			amount: '',
			currency: ''
		},
		casino_id: '',
		currency_id: '',
		game_id: '',
		ip: '',
		login_params: '',
		player_id: '',
		player_name: '',
		provider_id: '',
		session_id: ''
	},
	settings: {
		background_music: true,
		sound_effects: true,
		fast_spin: false,
		game_animation: true,
		splash_screen: true,
		keyboard_shortcuts: true,
		current_bet: null
	},
	reelTimeout: null,
	canStopReel: true,
	config: {
		bet_steps: [],
		coeffs: [
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] },
			{ coeffs: ['', '', '', '', ''] }
		],
		buyfeatureprice: 0,
		doublefeatureprice: 0,
		lines: [],
		minfs: 0,
		currency_prec: 0,
		rtp: 0,
		hasquest: false,
		hasbonus: false,
		hasbuybonus: false
		//TODO RTP, MAX COEF, FS amount array [8, 10, 12], Precision
	},
	//RESPONSES
	bonusWin: {
		bet: 0,
		scatters: 0,
		spins: 0,
		win: 0
	},
	bonusRestore: {},
	bonusRoundInfo: {},
	bonusRoundData: {
		roundID: '',
		totalbonusspins: 0,
		playedbonusspins: 0,
		retriggeredbonusspins: 0,
		progress: 0,
		status: '',
		wildmultiplier: 0,
		globalmultiplier: 0,
		bet: 0,
		balance: 0,
		totalWin: 0,
		bonussteps: [],
		wilds: [],
		currencyconfig: ''
	},
	freeSpin: {
		activation_end: '',
		bet_level: 0,
		bonus_restore: null,
		count: 0,
		create_date: 0,
		currency: '',
		end_date: '',
		free_spin_config_id: 0,
		freespin_count: 10,
		game_id: '',
		id: 0,
		player_id: '',
		start_date: '',
		status: '',
		total_win: 0
	},
	freeSpinLocal: {
		bet_level: 0,
		count: 0,
		status: '',
		isFinished: false,
		totalWin: 0,
		hasBonus: false
	},
	quest: {
		bet_level: 0,
		//TODO get data from back
		timer: 0,
		claimed: [0, 0, 0, 0],
		item_ids: [4, 3, 2, 1],
		progresses: [0, 1, 1, 0],
		seconds_left: 0,
		status: '',
		prizes: [],
		items: []
	},
	updateQuest: false,
	hasQuest: false,
	quest_claim: {
		claimed: false,
		activated: false,
		activated_item: 0,
		quest_data: null,
		step: false,
		status: '',
		leftBets: null,
		claimedNum: 0
	},
	quest_current: null,
	quest_is_active: false,
	errors: {
		code: 0,
		message: '',
		status: ''
	},
	notification: {
		code: 0,
		message: '',
		status: ''
	},
	//IN GAME CONFIGS
	currentBet: null,
	//TODO get presicion from configs (back)
	precision: 2,
	doubleChance: false,
	bonusBuy: false,
	isFreeSpin: false,
	bonusRevive: false,
	modal: '',
	fullscreen: false,
	win: 0,
	fastPlayDialogue: false,
	betPlaced: false,
	pause: false,
	autospin: {
		numOfBets: '',
		leftBets: 0,
		isAutoOn: false,
		pause: false
	},
	disabled: {
		bonus_widget: false,
		double_widget: false,
		info: false,
		settings: false,
		spin: false,
		auto: false,
		fast: false,
		quest_widget: false,
		bet_amount: false
	},
	bonusRoundActivated: '',
	reelComponent: null,
	uiComponent: null,
	bonusSpin: '10',
	bonusMult: '10',
	APP_WIDTH: 1920,
	APP_HEIGHT: 1080,
	rtp: 96.5,
	maxWin: 5000,
	time_left: 0,
	ReelConfig: null
};
